import { StyledMenuItem } from './MenuItem.styles';

export default StyledMenuItem;
